import { ErrorResponseErrorItemCodeIntegrationKey } from '../../../../typings/api/skymap/rest/v1/.common';

export const translations: Record<ErrorResponseErrorItemCodeIntegrationKey, string> = {
  'integration_key:missing': 'Integrationsnyckeln saknas.',
  'integration_key:invalid': 'Integrationsnyckeln är inte giltig.',
};
